import * as Enumerable from 'linq';
import { EntityLink } from '../entity';
import { BillAllocation, InvoiceAllocation } from './invoice.allocation';

export class InvoiceAllocationUtility {

    public static getAllInvoices(allocations: Array<InvoiceAllocation>): EntityLink[] {

        if (!allocations?.length) return [];

        const listInvoiceId = Enumerable
            .from(allocations)
            .where(item => !!item.fromInvoice && !!item.toInvoice)
            .select(item => [item.fromInvoice, item.toInvoice])
            .selectMany(item => item)
            .distinct(item => item._id)
            .toArray();

        return listInvoiceId;
    }

    public static getAllBill(allocations: Array<BillAllocation>): EntityLink[] {

        if (!allocations?.length) return [];

        const listInvoiceId = Enumerable
            .from(allocations)
            .where(item => !!item.fromBill && !!item.toBill)
            .select(item => [item.fromBill, item.toBill])
            .selectMany(item => item)
            .distinct(item => item._id)
            .toArray();

        return listInvoiceId;
    }
}